import React from 'react';
function AccountSettings() {
    return (<>
        <h1>Account Settings</h1>
    </>);
}

export default AccountSettings;